import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SeprateCard = ({ name, link, role }) => {
  return (
    <Card className='bg-custom-3 shadow-sm' style={{ minHeight: '9.5rem' }}>
      <Card.Header as='h5' className='text-dark'>
        {name}
      </Card.Header>
      <Card.Body>
        <Link to={`/home/${role}/${name}`}>
          <Button variant='dark'>Go To Course</Button>
        </Link>
      </Card.Body>
    </Card>
  );
};

export default SeprateCard;
